<template>
  <div class="statistics" style="padding:15px;">
    <el-row :gutter="25">
      <el-col :xs="24" :sm="24" :md="24" :lg="8">
        <el-card class="box-card summary">
          <p style="font-size:medium">Registered Users</p>
          <p style="font-size:xx-large">{{ data.total }} </p>
          <div style="font-size: medium; margin-top: 5px;">
            <p  style="font-size: small">Summary </p>
            <hr class="divider" />
            <p>New users on the last 30 days <b style="float: right">{{ data.new_registered_users }}</b></p>
            <!-- <p>Number of Android vs iOS users <b style="float: right">n/a</b></p> -->
            <p>Reported Concerns <b style="float: right">{{ data.concerns }}</b></p>
            <p>Suggestions <b style="float: right">{{ data.suggestions }}</b></p>
            <p>Reported Heroes <b style="float: right">{{ data.heroes }}</b></p>
            <p>Invites <b style="float: right">{{ invites }}</b></p>

            <p>Total Donations <b style="float: right">&#8369; {{ donations.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</b></p>
          </div>
        </el-card>
      </el-col>
       <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8">
        <el-card class="box-card">
          <h2 slot="title" class="stats-label">Call to action</h2>
          Work in progress
        </el-card >
      </el-col> -->
      <el-col :xs="24" :sm="24" :md="12" :lg="8">
         <el-card class="box-card tabs">
           <el-tabs v-model="activeName" >
            <el-tab-pane label="Gender" name="gender"><gender v-if="activeName == 'gender'" :data="gender"  /></el-tab-pane>
            <el-tab-pane label="Age" name="age"><age-bracket  v-if="activeName == 'age'" :data="ageBracket" /></el-tab-pane>
          </el-tabs>
          <!-- <div slot="header" class="clearfix">
            <h2 class="stats-label">Gender</h2>
          </div>
          <gender :data="gender"  /> -->
        </el-card >


      </el-col>
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <h2 class="stats-label">Province</h2>
        <provice :data="province"/>
      </el-col> -->
      <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <h2 class="stats-label">Age</h2>
          </div>
          <age-bracket :data="ageBracket" />
        </el-card >
      </el-col> -->
    </el-row>
    <el-row :gutter="25">
      <el-col :xs="24" :sm="24" :md="24" :lg="12">
        <el-card class="box-card" >
          <h2  slot="title" class="stats-label">Advocacies</h2>
          <div style="min-height: 350px; max-height: 550px; position: relative;">
            <advocacies :data="advocacies" />
          </div>
        </el-card >
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12">
        <el-card class="box-card" >
          <h2 slot="title" class="stats-label">Region</h2>
          <div style="min-height: 350px; max-height: 500px; position: relative;">
            <region :data="regions" />
          </div>
        </el-card >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Gender from './Gender'
import Provice from './Province'
import Region from './Region'
import Advocacies from './Advocacies'
import AgeBracket from './AgeBracket'
import {Row,Col,Card,TabPane,Tabs} from 'iview'

import Axios from 'axios'

export default {
  components: {
    'el-row': Row,
    'el-col': Col,
    'el-card': Card,
    'el-tab-pane': TabPane,
    'el-tabs': Tabs,
    Gender,
    Provice,
    Region,
    AgeBracket,
    Advocacies
  },
  data() {
    return {
      activeName: "gender",
      advocacies: {},
      regions: {}
    }
  },
  computed: {
    invites: {
      get() {
        if (!this.data.invites)
          return 0
        return this.data.invites.total
      }
    },
    donations: {
      get() {
        let total = 0;

        if (this.data.donations)
          this.data.donations.forEach(item => {
            total += item.amount
          })

        return total
      }
    },
    data: {
      get() {
        return this.$store.state.statistics.stat.data
      }
    },
    gender() {
      return this.data.gender || {}
    },
    province() {
      return this.data.province || {}
    },
    region() {
      return this.data.region || {}
    },
    // advocacies() {
    //   return this.data.advocacies || {}
    // },
    ageBracket() {
      return this.data.age || {}
    }
  },
  mounted() {
    this.$store.dispatch('statistics/getStats', { id: '500E3120-B0F8-29C3-5D76-E43F66098341'})
      .then(() => {
        this.advocacies = this.data.interests
        this.regions = this.data.region
        return;
        this.advocacies = {
          'Education': 20,
          'Environment': 5,
          'Gender Equality': 6,
          'Good Governance': 1,
          'Health': 6,
          'Indigenous Peoples Welfare': 3,
          'Marawi Rehabilitation': 7
        }

        this.regions=  {
          "NCR": 3,
          "CAR": 8,
          "Region 1": 1,
          "Region 2": 3,
          "Region 3": 9,
          "Region 4-A": 6,
          "Region 4-B": 7,
          "Region 5": 3,
          "Region 6": 6,
          "Region 7": 4,
          "Region 8": 2,
          "Region 9": 1,
          "Region 10": 8,
          "Region 11": 15,
          "Region 12": 5,
          "Region 13": 1,
          "ARMM": 1,
          "others": 8
        }
      })
  }

}
</script>

<style>
.stats-label {
  font-size: small;
}


.statistics .box-card {
  min-height: 250px;
  box-shadow: unset !important;
   margin-bottom: 15px;
}

.summary {
  color: #ffffff !important;
  background: rgba(54, 162, 235, 1) !important;
}

.divider {
    border: 0;
    height: 1px;
    margin: 6px 0;
}

.box-card.tabs .el-card__body{
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}

.box-card.tabs .el-tabs__content {
  padding: 0 10px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
